export default {
    common: {
        unit: 'Rmb'
    },
    login: {
        login: ''
    }
}
